export default "__VITE_ASSET__B$j80sW6__"